import { render, staticRenderFns } from "./CustomerFreeDiscribeTemplate.vue?vue&type=template&id=369d8df8&scoped=true&"
import script from "./CustomerFreeDiscribeTemplate.vue?vue&type=script&lang=ts&"
export * from "./CustomerFreeDiscribeTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerFreeDiscribeTemplate.vue?vue&type=style&index=0&id=369d8df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d8df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VTextarea})
